import React, { useEffect } from "react";
import { Footer } from "../components/Relaunch";
import { Navigation } from "../components/navigation";

const AppPrivacy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Navigation /><main id="main">
      
      <div id="privacy-policy" className="text-left">
        <div className="container">
          <div className="privacy-header">
            <h1>Política de Privacidade do CoffeeIn Club</h1>
            <p className="last-updated">Última atualização: 23 de outubro de 2025</p>
          </div>

          <div className="privacy-content">
            <section>
              <h2>1. Introdução</h2>
              <p>
                Bem-vindo ao CoffeeIn Club. Esta Política de Privacidade descreve como coletamos, 
                usamos, armazenamos e protegemos suas informações pessoais quando você utiliza 
                nosso aplicativo móvel e serviços relacionados.
              </p>
              <p>
                Ao usar o CoffeeIn Club, você concorda com a coleta e uso de informações de acordo 
                com esta política. Levamos sua privacidade a sério e estamos comprometidos em 
                proteger seus dados pessoais.
              </p>
            </section>

            <section>
              <h2>2. Informações que Coletamos</h2>
              
              <h3>2.1 Informações Fornecidas por Você</h3>
              <ul>
                <li><strong>Informações de Cadastro:</strong> Nome, e-mail, telefone, data de nascimento</li>
                <li><strong>Informações de Perfil:</strong> Foto de perfil, preferências de café</li>
                <li><strong>Informações de Pagamento:</strong> Dados de cartão de crédito processados 
                através de provedores de pagamento seguros (não armazenamos dados completos de cartão)</li>
                <li><strong>Informações de Localização:</strong> Localização para encontrar cafeterias próximas 
                (apenas quando você autoriza)</li>
              </ul>

              <h3>2.2 Informações Coletadas Automaticamente</h3>
              <ul>
                <li><strong>Dados de Uso:</strong> Como você interage com o aplicativo, cafeterias visitadas, 
                pedidos realizados</li>
                <li><strong>Dados do Dispositivo:</strong> Tipo de dispositivo, sistema operacional, 
                identificador único do dispositivo, endereço IP</li>
                <li><strong>Dados de Localização:</strong> Localização aproximada baseada em IP ou localização 
                precisa quando autorizada</li>
                <li><strong>Tokens de Push:</strong> Tokens de notificação push para envio de atualizações 
                e ofertas</li>
              </ul>

              <h3>2.3 Informações de Terceiros</h3>
              <ul>
                <li><strong>Redes Sociais:</strong> Se você optar por conectar sua conta com redes sociais 
                (Facebook, Google), podemos receber informações básicas do perfil</li>
                <li><strong>Cafeterias Parceiras:</strong> Informações sobre seus pedidos e visitas às 
                cafeterias participantes</li>
              </ul>
            </section>

            <section>
              <h2>3. Como Usamos Suas Informações</h2>
              <p>Utilizamos as informações coletadas para:</p>
              <ul>
                <li><strong>Fornecer e Melhorar Nossos Serviços:</strong> Processar pedidos, gerenciar sua 
                conta, personalizar sua experiência</li>
                <li><strong>Comunicação:</strong> Enviar confirmações de pedidos, atualizações de status, 
                notificações importantes, ofertas promocionais (você pode cancelar a inscrição a qualquer momento)</li>
                <li><strong>Programa de Fidelidade:</strong> Gerenciar pontos, recompensas, cupons e 
                assinaturas</li>
                <li><strong>Análise e Melhoria:</strong> Analisar como os usuários utilizam o aplicativo 
                para melhorar funcionalidades</li>
                <li><strong>Segurança:</strong> Detectar e prevenir fraudes, garantir a segurança do 
                aplicativo</li>
                <li><strong>Cumprimento Legal:</strong> Cumprir obrigações legais e regulatórias</li>
                <li><strong>Marketing:</strong> Enviar ofertas personalizadas, novidades e promoções 
                (com seu consentimento)</li>
              </ul>
            </section>

            <section>
              <h2>4. Compartilhamento de Informações</h2>
              <p>Podemos compartilhar suas informações com:</p>
              
              <h3>4.1 Cafeterias Parceiras</h3>
              <p>
                Compartilhamos informações necessárias para processar seus pedidos (nome, itens do pedido, 
                preferências) com as cafeterias onde você faz pedidos.
              </p>

              <h3>4.2 Provedores de Serviços</h3>
              <ul>
                <li>Processadores de pagamento (Stripe, PayPal, etc.)</li>
                <li>Serviços de hospedagem e infraestrutura</li>
                <li>Serviços de análise e métricas</li>
                <li>Serviços de notificação push (Firebase Cloud Messaging, Apple Push Notification Service)</li>
                <li>Serviços de e-mail e comunicação</li>
              </ul>

              <h3>4.3 Requisitos Legais</h3>
              <p>
                Podemos divulgar suas informações quando exigido por lei, regulamentação, processo legal 
                ou solicitação governamental.
              </p>

              <h3>4.4 Transferência de Negócios</h3>
              <p>
                Em caso de fusão, aquisição ou venda de ativos, suas informações podem ser transferidas 
                para a entidade sucessora.
              </p>

              <h3>4.5 Com Seu Consentimento</h3>
              <p>
                Podemos compartilhar suas informações para outros fins com seu consentimento explícito.
              </p>
            </section>

            <section>
              <h2>5. Segurança dos Dados</h2>
              <p>
                Implementamos medidas de segurança técnicas e organizacionais para proteger suas 
                informações pessoais:
              </p>
              <ul>
                <li>Criptografia de dados em trânsito (TLS/SSL)</li>
                <li>Criptografia de dados sensíveis em repouso</li>
                <li>Controles de acesso rigorosos</li>
                <li>Monitoramento e auditoria de segurança</li>
                <li>Testes de segurança regulares</li>
                <li>Conformidade com padrões de segurança da indústria (PCI DSS para pagamentos)</li>
              </ul>
              <p>
                No entanto, nenhum método de transmissão pela Internet ou armazenamento eletrônico é 
                100% seguro. Embora nos esforcemos para proteger suas informações, não podemos garantir 
                sua segurança absoluta.
              </p>
            </section>

            <section>
              <h2>6. Retenção de Dados</h2>
              <p>
                Mantemos suas informações pessoais pelo tempo necessário para cumprir os propósitos 
                descritos nesta Política de Privacidade, a menos que um período de retenção mais longo 
                seja exigido ou permitido por lei.
              </p>
              <p>Períodos de retenção típicos:</p>
              <ul>
                <li>Dados de conta: Enquanto sua conta estiver ativa ou conforme necessário para 
                fornecer serviços</li>
                <li>Dados de transação: 5 anos para fins fiscais e contábeis</li>
                <li>Dados de marketing: Até você cancelar a inscrição ou solicitar exclusão</li>
                <li>Dados de log: 90 dias</li>
              </ul>
            </section>

            <section>
              <h2>7. Seus Direitos de Privacidade</h2>
              <p>Você tem os seguintes direitos em relação às suas informações pessoais:</p>
              <ul>
                <li><strong>Acesso:</strong> Solicitar acesso aos dados pessoais que mantemos sobre você</li>
                <li><strong>Correção:</strong> Solicitar correção de informações imprecisas ou incompletas</li>
                <li><strong>Exclusão:</strong> Solicitar a exclusão de suas informações pessoais (direito 
                ao esquecimento)</li>
                <li><strong>Portabilidade:</strong> Solicitar uma cópia de suas informações em formato 
                estruturado e legível por máquina</li>
                <li><strong>Restrição:</strong> Solicitar a restrição do processamento de suas informações</li>
                <li><strong>Objeção:</strong> Opor-se ao processamento de suas informações</li>
                <li><strong>Retirada de Consentimento:</strong> Retirar consentimento previamente dado</li>
                <li><strong>Reclamação:</strong> Apresentar reclamação a uma autoridade de proteção de dados</li>
              </ul>
              <p>
                Para exercer esses direitos, entre em contato conosco através dos canais listados na 
                seção "Contato" abaixo.
              </p>
            </section>

            <section>
              <h2>8. Localização e Serviços de Localização</h2>
              <p>
                Nosso aplicativo utiliza serviços de localização para:
              </p>
              <ul>
                <li>Mostrar cafeterias próximas a você</li>
                <li>Calcular rotas e distâncias</li>
                <li>Fornecer recomendações baseadas em localização</li>
                <li>Melhorar a experiência do usuário com conteúdo relevante</li>
              </ul>
              <p>
                Você pode controlar as permissões de localização através das configurações do seu 
                dispositivo. Desativar a localização pode limitar algumas funcionalidades do aplicativo.
              </p>
              <p>
                <strong>iOS:</strong> Configurações &gt; Privacidade &gt; Serviços de Localização &gt; CoffeeIn Club
              </p>
              <p>
                <strong>Android:</strong> Configurações &gt; Aplicativos &gt; CoffeeIn Club &gt; Permissões &gt; Localização
              </p>
            </section>

            <section>
              <h2>9. Notificações Push</h2>
              <p>
                Com seu consentimento, podemos enviar notificações push para:
              </p>
              <ul>
                <li>Atualizações de status do pedido</li>
                <li>Ofertas e promoções exclusivas</li>
                <li>Novidades e atualizações do aplicativo</li>
                <li>Lembretes de pontos e recompensas</li>
              </ul>
              <p>
                Você pode desativar notificações push a qualquer momento através das configurações do 
                seu dispositivo ou do aplicativo.
              </p>
            </section>

            <section>
              <h2>10. Cookies e Tecnologias Similares</h2>
              <p>
                Utilizamos cookies e tecnologias similares para:
              </p>
              <ul>
                <li>Manter você conectado</li>
                <li>Lembrar suas preferências</li>
                <li>Analisar o uso do aplicativo</li>
                <li>Personalizar conteúdo e anúncios</li>
              </ul>
              <p>
                Você pode controlar cookies através das configurações do seu navegador ou dispositivo.
              </p>
            </section>

            <section>
              <h2>11. Privacidade de Crianças</h2>
              <p>
                Nossos serviços não são direcionados a menores de 18 anos. Não coletamos intencionalmente 
                informações pessoais de crianças. Se você é pai ou responsável e acredita que seu filho 
                nos forneceu informações pessoais, entre em contato conosco para que possamos tomar as 
                medidas apropriadas.
              </p>
            </section>

            <section>
              <h2>12. Links para Sites de Terceiros</h2>
              <p>
                Nosso aplicativo pode conter links para sites de terceiros. Não somos responsáveis 
                pelas práticas de privacidade desses sites. Recomendamos que você leia as políticas 
                de privacidade de cada site que visita.
              </p>
            </section>

            <section>
              <h2>13. Transferências Internacionais de Dados</h2>
              <p>
                Suas informações podem ser transferidas e mantidas em servidores localizados fora do 
                seu país de residência, onde as leis de proteção de dados podem ser diferentes. 
                Tomamos medidas para garantir que suas informações recebam proteção adequada.
              </p>
            </section>

            <section>
              <h2>14. Lei Geral de Proteção de Dados (LGPD)</h2>
              <p>
                Em conformidade com a LGPD (Lei nº 13.709/2018), garantimos:
              </p>
              <ul>
                <li>Transparência no tratamento de dados pessoais</li>
                <li>Finalidade específica para coleta de dados</li>
                <li>Segurança e proteção dos dados</li>
                <li>Direitos dos titulares dos dados</li>
                <li>Responsabilização e prestação de contas</li>
              </ul>
              <p>
                <strong>Base Legal:</strong> Processamos seus dados com base em:
              </p>
              <ul>
                <li>Consentimento explícito</li>
                <li>Execução de contrato</li>
                <li>Cumprimento de obrigação legal</li>
                <li>Legítimo interesse</li>
              </ul>
            </section>

            <section>
              <h2>15. Alterações nesta Política</h2>
              <p>
                Podemos atualizar esta Política de Privacidade periodicamente. Notificaremos você sobre 
                alterações significativas através do aplicativo ou por e-mail. A data da "Última 
                atualização" no topo desta página indica quando a política foi revisada pela última vez.
              </p>
              <p>
                Recomendamos que você revise esta política periodicamente para se manter informado sobre 
                como protegemos suas informações.
              </p>
            </section>

            <section>
              <h2>16. Contato</h2>
              <p>
                Se você tiver dúvidas, preocupações ou solicitações relacionadas a esta Política de 
                Privacidade ou ao tratamento de suas informações pessoais, entre em contato conosco:
              </p>
              <div className="contact-info">
                <p><strong>E-mail de Privacidade:</strong> privacy@coffeein.club</p>
                <p><strong>E-mail de Suporte:</strong> suporte@coffeein.club</p>
                <p><strong>Encarregado de Proteção de Dados (DPO):</strong> dpo@coffeein.club</p>
              </div>
              <p>
                Responderemos às suas solicitações dentro de 15 dias úteis, conforme exigido pela LGPD.
              </p>
            </section>

            <section>
              <h2>17. Consentimento</h2>
              <p>
                Ao utilizar o CoffeeIn Club, você reconhece que leu, compreendeu e concorda com os 
                termos desta Política de Privacidade.
              </p>
            </section>
          </div>
        </div>
      </div>

      </main><Footer />
    </div>
  );
};

export default AppPrivacy;

